import { LangText } from '@/components'
import OutLink from '@/components/OutLink'
import { VIP_URL } from '@/constants'
import { PlatformEnum } from '@/service/api/types'
import { preFixImgUrl } from '@/utils'

const EXPERIENCE_ITEMS = [
  {
    id: 'shoppingConcierge',
    image: 'a3ee507560f7f0a50bfbfa6bc9622431.png',
    titleKey: 'vip.experience.items.shoppingConcierge.title',
    descriptionKey: 'vip.experience.items.shoppingConcierge.description',
    available: true,
  },
  {
    id: 'hotelReservation',
    image: '444f50c8c8c0cbec9295774b612936ee.png',
    titleKey: 'vip.experience.items.hotelReservation.title',
    descriptionKey: 'vip.experience.items.hotelReservation.description',
    available: false,
  },
  {
    id: 'airportReception',
    image: '7516f42b9f0799e5f53ba14e8c1c271e.png',
    titleKey: 'vip.experience.items.airportReception.title',
    descriptionKey: 'vip.experience.items.airportReception.description',
    available: false,
  },
] as const

const ExperienceSection = () => (
  <section className="w-full bg-[#FAFAFA] pt-[60px]">
    <div className="mx-auto w-[1200px]">
      <div className="flex flex-col items-center">
        <LangText
          lngKey="vip.experience.title"
          className="text-[36px] font-bold leading-[50px] text-[#000]"
        />
        <span className="mt-[20px] h-[4px] w-[104px] rounded-full bg-primary" />
      </div>

      <div className="mt-[48px] grid grid-cols-3 gap-[32px]">
        {EXPERIENCE_ITEMS.map((item) => (
          <article
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-[20px] border border-[#E3DCDD] bg-white transition-[border-color,box-shadow] duration-300 hover:border-primary/20 hover:shadow-[0_12px_28px_rgba(0,0,0,0.08)]"
          >
            <div className="h-[219px] shrink-0 overflow-hidden">
              <img
                src={preFixImgUrl(item.image)}
                alt=""
                className="object-cover w-full h-full transition-transform duration-500 ease-out group-hover:scale-110"
                draggable={false}
              />
            </div>

            <div className="flex min-h-0 flex-1 flex-col items-center p-[20px] text-center">
              <LangText
                lngKey={item.titleKey}
                className="text-[20px] font-bold leading-[28px] text-[#000]"
              />
              <LangText
                lngKey={item.descriptionKey}
                className="mt-[8px] mb-[20px] text-[14px] leading-[20px] text-[#979797] break-all word-break-all"
              />

              {item.available ? (
                <div className="mt-auto">
                  <OutLink platform={PlatformEnum.VIP} linUrl={VIP_URL}>
                    <button
                      type="button"
                      className="h-[38px] cursor-pointer rounded-full bg-linear-to-b from-[#FFC36A] to-[#E8951B] px-[26px] text-[16px] font-medium text-white transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_8px_18px_rgba(232,149,27,0.28)]"
                    >
                      <LangText lngKey="vip.experience.bookNow" />
                    </button>
                  </OutLink>
                </div>
              ) : (
                <button
                  type="button"
                  disabled
                  className="mt-auto h-[38px] cursor-not-allowed rounded-full border border-[#FEDCA7] px-[26px] text-[16px] font-medium text-[#DC8414] bg-[#FFFAF3]"
                >
                  <LangText lngKey="common.status.stayTuned" />
                </button>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
)

export default ExperienceSection
